import { CartItem, CartItemProgramClass } from "../interfaces/cart";
import { nanoid } from "nanoid";

export function parseCartItems(jsonString: string): CartItem[] {
    const rawItems: any[] = JSON.parse(jsonString);
    return rawItems.map((rawItem) => {
        switch (rawItem.itemType) {
            case "programClass":
                return rawItem as CartItemProgramClass;

            // ... handle other itemTypes
            default:
                throw new Error(`Unknown itemType: ${rawItem.itemType}`);
        }
    });
}

export function getCartItemId(): string {
    return nanoid();
}
